module.exports = __webpack_public_path__ + "assets/img/wechat-sz.4cebc41c.jpg";